import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import pjson from "../package.json";
import App from "./App";

const isProd = import.meta.env.VITE_ENV === "production";
const isDev = import.meta.env.MODE === "development";

if (!isDev) {
  Sentry.init({
    dsn: "https://64de61380b7e4759bfc61ece5d52ac26@o4505076179075072.ingest.sentry.io/4505084982591488",
    environment: isProd ? "production" : "staging",
    release: pjson.version,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Performance Monitoring
    tracesSampleRate: isProd ? 0.25 : 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <Router>
    <App />
  </Router>,
);
